import { Avatar as MatAvatar } from '@material-ui/core';
import vectorImage from 'assets/images/Vector.png';
import { Slider, Icon, IconTextArea } from 'components';
import PropTypes from 'prop-types';
import React from 'react';
import { useCalTime } from 'utils/hooks/useCalTime';
import {
  UiAlbumSlider,
  UiAlbumContent,
  UiClose,
  UiAlbumTop,
  UiAlbumItem,
  UiAlbumButtom,
  UiAlbumPost,
  UiAlbumUser,
  UiAlbumUserInfo,
  UiAlbumPostContent,
  UiPostThumbUp,
  UiAlbumPostActionBox,
  UiAlbumPostActionItem,
  UiAlbumReplieBox,
  UiAlbumInput,
  UiAlbumReplieItem,
  UiAlbumReplieContent,
  UiAlbumReplieAction,
  UiShowAllMessage,
  UiThumbUp,
  UiFileIcon,
} from './AlbumSlider.style';

/**
 * slider 有內容
 */


const sliderSetting = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  adaptiveHeight: true,
};
export const AlbumSlider = ({
  type = 'contentSlider',
  isOpen,
  close = () => { },
  defaultData,
  replieMessage = () => { },
  showAllReplies = () => { },
  changeLikeUserState = () => { },
  initalSlide = 0,
  ownerId = ''
}) => {
  const [calTime] = useCalTime();
  const isLiked = () => defaultData.likedUsers ?
    defaultData.likedUsers.some(item => item === ownerId) :
    false;

  const mediaShow = (type, item) => {
    switch (type) {
      case 'jpg':
      case 'png':
      case 'gif':
      case 'jpeg':
      case 'svg':
      case 'image':
        return (
          <img src={item.attachmentUrl} alt={item.attachmentUrl} />
        );
      case 'mp4':
      case 'mp3':
      case 'webm':
      case 'wav':
      case 'video':
        return (
          <video controls>
            <source src={item.attachmentUrl} type={item.attachmentType} />
          </video>
        );
      default:
        return (
          <UiFileIcon>
            <div className="image">
              <img src={vectorImage} alt="vector" />
              此檔案類型無法預覽
            </div>
            <div className="fileName">{item.attachmentName}</div>
          </UiFileIcon>
        );
    }
  };

  const downloadFile = async (u, name) => {
    const fileBlob = await fetch(u).then(res => res.blob());
    const url = window.URL.createObjectURL(new Blob([fileBlob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  };

  return isOpen && (
    <UiAlbumSlider onClick={e => close(e)}>
      <div>
        <UiAlbumContent>
          <UiAlbumTop>
            <UiClose aria-label="關閉" onClick={() => close()}><Icon name="close" haveBg={false} /></UiClose>
            <Slider config={sliderSetting} initalSlide={initalSlide}>
              {
                defaultData.attachments.map((item, index) => {
                  return (
                    <UiAlbumItem key={item.attachmentUrl}>
                      <div>
                        {
                          mediaShow(item.attachmentType?.split('/')[0] || item.attachmentName?.split('.')[1], item)
                        }
                        {
                          item.attachmentUrl.indexOf('http') === 0 &&
                          <button aria-label={`下載圖片${index + 1}`} onClick={() => downloadFile(item.attachmentUrl, item.attachmentName)}>
                            <Icon name="getApp" />
                          </button>
                        }
                      </div>
                    </UiAlbumItem>
                  );
                })
              }
            </Slider>
          </UiAlbumTop>
          {type === 'contentSlider' &&
            <UiAlbumButtom>
              <UiAlbumPost>
                <UiAlbumUser>
                  <MatAvatar src="" />
                  <UiAlbumUserInfo>
                    <div>{defaultData.ownerName}</div>
                    <div>{calTime(defaultData.publishedAt)}</div>
                  </UiAlbumUserInfo>
                </UiAlbumUser>
                <UiAlbumPostContent>
                  {defaultData.content}
                </UiAlbumPostContent>
                <UiPostThumbUp>
                  <Icon title='讚' name='thumbUp' />
                  <span>{defaultData.likedUsers ? defaultData.likedUsers.length : 0}</span>
                </UiPostThumbUp>
                <UiAlbumPostActionBox>
                  <UiAlbumPostActionItem
                    onClick={() => changeLikeUserState(defaultData.id, isLiked(), 'picture')}
                    isLiked={isLiked()}
                  >
                    <Icon title='讚' name='thumbUp' haveBg={false} />
                    <span>讚</span>
                  </UiAlbumPostActionItem>
                </UiAlbumPostActionBox>
              </UiAlbumPost>
              {
                (
                  defaultData.replies &&
                  defaultData.replies.total !== defaultData.replies.posts.length
                ) &&
                <UiShowAllMessage>
                  <span
                    onClick={() => showAllReplies(defaultData.id, defaultData.replies.total)}
                  >
                    顯示全部留言
                  </span>
                </UiShowAllMessage>
              }
              {
                defaultData.replies &&
                <UiAlbumReplieBox>
                  {
                    defaultData.replies.posts.map(replie => {
                      replie.isLiked = replie.likedUsers ? replie.likedUsers.some(item => item === ownerId) : false;
                      return (
                        <UiAlbumReplieItem key={replie.id}>
                          <UiAlbumUser>
                            <MatAvatar src="" alt={replie.ownerId} />
                          </UiAlbumUser>
                          <UiAlbumReplieContent>
                            <div>
                              <span>{replie.ownerName}</span>
                              {
                                replie.content
                              }
                              {
                                (replie.attachments && replie.attachments.length > 0) &&
                                <img
                                  src={replie.attachments[0].attachmentUrl}
                                  alt={replie.attachments[0].attachmentName}
                                />
                              }
                              {
                                replie.likedUsers &&
                                <UiThumbUp>
                                  <Icon title='讚' name='thumbUp' />
                                  {replie.likedUsers.length}
                                </UiThumbUp>
                              }
                            </div>
                            <UiAlbumReplieAction>
                              <button onClick={() => changeLikeUserState(replie.id, replie.isLiked)}>
                                {replie.isLiked ? '收回讚' : '讚'}
                              </button>
                            </UiAlbumReplieAction>
                          </UiAlbumReplieContent>
                        </UiAlbumReplieItem>
                      );
                    })
                  }
                </UiAlbumReplieBox>
              }
              <UiAlbumInput>
                <IconTextArea isCanUploadFile={false} onKeyPress={params => replieMessage(params, defaultData.id)} />
              </UiAlbumInput>
            </UiAlbumButtom>}
        </UiAlbumContent>
      </div>
    </UiAlbumSlider>
  );
};

AlbumSlider.propTypes = {
  type: PropTypes.oneOf(['contentSlider', 'slider']),
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  defaultData: PropTypes.object,
  replieMessage: PropTypes.func,
  showAllReplies: PropTypes.func,
  changeLikeUserState: PropTypes.func,
  initalSlide: PropTypes.number,
  ownerId: PropTypes.string
};


